/*
 * hfb-reveal — Baseline motion (layout.md §3 / BRAND-PARALLAX).
 * Fade-up on scroll-into-view via IntersectionObserver, gently staggered.
 * Respects prefers-reduced-motion (elements are shown immediately, no transition).
 * No parallax, no scroll-jacking, no count-up.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = document.querySelectorAll('.hfb-reveal');
  if (!nodes.length) return;

  if (reduce || !('IntersectionObserver' in window)) {
    nodes.forEach(function (n) { n.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
      setTimeout(function () { el.classList.add('is-in'); }, delay);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  nodes.forEach(function (n) { io.observe(n); });
})();
